"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const bind_decorator_1 = __importDefault(require("bind-decorator"));
const classnames_1 = __importDefault(require("classnames"));
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const react_1 = __importDefault(require("react"));
const react_router_hash_link_1 = require("react-router-hash-link");
const react_toastify_1 = require("react-toastify");
const Button_1 = __importDefault(require("../../../common/js/atoms/Button"));
const ButtonVariant_1 = __importDefault(require("../../../common/js/enums/ButtonVariant"));
const noop_1 = require("../../../common/js/helper/noop");
const translation_1 = require("../../../common/js/helper/translation");
const AuthorizationStore_1 = __importDefault(require("../../../common/js/stores/AuthorizationStore"));
const UserProfileAddress_1 = __importDefault(require("../../atoms/UserProfileAddress"));
const Paths_1 = require("../../constants/Paths");
const CartErrorLevels_1 = __importDefault(require("../../enums/CartErrorLevels"));
const DataLayerActions_1 = __importDefault(require("../../enums/DataLayerActions"));
const DataLayerLabels_1 = __importDefault(require("../../enums/DataLayerLabels"));
const address_1 = require("../../helper/address");
const dataLayer_1 = require("../../helper/dataLayer");
const history_1 = require("../../helper/history");
const path_1 = require("../../helper/path");
const MassiveCompany_1 = __importDefault(require("../../stores/MassiveCompany"));
const ShopwareCart_1 = __importDefault(require("../../stores/ShopwareCart"));
const ShopwareContext_1 = __importDefault(require("../../stores/ShopwareContext"));
const ShopwareOrder_1 = __importDefault(require("../../stores/ShopwareOrder"));
const ShopwarePaymentMethods_1 = __importDefault(require("../../stores/ShopwarePaymentMethods"));
const SuluResellers_1 = __importDefault(require("../../stores/SuluResellers"));
const ShopCheckoutLayout_1 = __importDefault(require("../ShopCheckoutLayout"));
const ShopCheckoutSummaryMethod_1 = __importDefault(require("../ShopCheckoutSummaryMethod"));
class ShopCheckoutSummary extends react_1.default.Component {
    promiseCheckoutDataPromise = Promise.resolve();
    purchaseOrderNumberReactionDisposer;
    taxIdReactionDisposer;
    customerComment = ShopwareCart_1.default.cart?.customerComment ?? '';
    hasTaxId = false;
    initialLoading = true;
    isSubmitButtonReady = false;
    isCheckedTermsAndConditions = false;
    isCreatingOrder = false;
    loadingCounter = 0;
    purchaseOrderNumber = '';
    taxId = '';
    isAdyenPaymentMethod = false;
    constructor(props) {
        super(props);
        (0, mobx_1.makeObservable)(this, {
            customerComment: mobx_1.observable,
            hasTaxId: mobx_1.observable,
            initialLoading: mobx_1.observable,
            isSubmitButtonReady: mobx_1.observable,
            isCheckedTermsAndConditions: mobx_1.observable,
            isCreatingOrder: mobx_1.observable,
            loadingCounter: mobx_1.observable,
            purchaseOrderNumber: mobx_1.observable,
            taxId: mobx_1.observable,
            buttonIsDisabled: mobx_1.computed,
            checkoutRequiresTaxId: mobx_1.computed,
            checkoutRequiresPurchaseOrderNumber: mobx_1.computed,
            isResellerSelected: mobx_1.computed,
            resellerCountryCode: mobx_1.computed,
            isAdyenPaymentMethod: mobx_1.observable,
            isLoading: mobx_1.computed,
            resellers: mobx_1.computed,
            selectedResellerId: mobx_1.computed,
            addresses: mobx_1.computed,
            billingAddress: mobx_1.computed,
            shippingAddress: mobx_1.computed,
            shippingMethodLabel: mobx_1.computed,
            updateTaxId: mobx_1.action.bound,
            onCreateOrder: mobx_1.action.bound,
            onSelectReseller: mobx_1.action.bound,
            updatePurchaseOrderNumber: mobx_1.action.bound,
        });
    }
    get buttonIsDisabled() {
        return (this.isCreatingOrder ||
            !this.isSubmitButtonReady ||
            (this.checkoutRequiresTaxId && !this.taxId) ||
            !this.isCheckedTermsAndConditions ||
            (this.checkoutRequiresPurchaseOrderNumber && !this.purchaseOrderNumber));
    }
    get checkoutRequiresTaxId() {
        return true === ShopwareContext_1.default.contextExtension?.checkoutRequiresTaxId;
    }
    get checkoutRequiresPurchaseOrderNumber() {
        return true === ShopwareContext_1.default.customFields?.massivePonumberRequired;
    }
    get isResellerSelected() {
        return null !== this.resellers && this.resellers.length > 0 && null !== this.selectedResellerId;
    }
    get resellerCountryCode() {
        return MassiveCompany_1.default.company?.defaultMassiveAddress?.country?.iso ?? null;
    }
    get isLoading() {
        return this.loadingCounter > 0;
    }
    get resellers() {
        if (null === this.resellerCountryCode) {
            return null;
        }
        return SuluResellers_1.default.getResellersForCountryWithExternalId(this.resellerCountryCode);
    }
    get selectedResellerId() {
        const resellerId = ShopwareContext_1.default.contextExtension?.massiveResellerId ?? null;
        if (null === resellerId || null === this.resellers) {
            return null;
        }
        return this.resellers.find((reseller) => reseller.externalId === resellerId)?.externalId ?? null;
    }
    get addresses() {
        return (0, address_1.getAddressesOfCompany)(MassiveCompany_1.default.company);
    }
    get billingAddress() {
        return (0, address_1.getCompanyAddressById)(ShopwareContext_1.default.currentBillingAddressId, MassiveCompany_1.default.company);
    }
    get shippingAddress() {
        return (0, address_1.getCompanyAddressById)(ShopwareContext_1.default.currentShippingAddressId, MassiveCompany_1.default.company);
    }
    get shippingMethodLabel() {
        const parts = [
            ShopwareContext_1.default.currentShippingMethod?.translated?.name ?? '',
            ShopwareContext_1.default.contextExtension?.shippingServiceLabel ?? '',
        ];
        return parts
            .filter((value) => !!value)
            .join(' - ')
            .trim();
    }
    componentDidMount() {
        (0, mobx_1.action)(() => {
            this.initialLoading = true;
            this.isSubmitButtonReady = false;
            (0, dataLayer_1.pushToDataLayer)({
                action: DataLayerActions_1.default.checkoutProgress,
                [DataLayerLabels_1.default.eventLabel]: (0, translation_1.t)('shop_checkout_page.stepper.summary'),
            });
            this.purchaseOrderNumber = ShopwareContext_1.default.contextExtension?.massivePurchaseOrderNumber ?? '';
            this.taxId = ShopwareContext_1.default.contextExtension?.taxId ?? '';
            ShopwareContext_1.default.loadContext()
                .then(() => {
                if (!ShopwareContext_1.default.currentPaymentMethod) {
                    (0, mobx_1.runInAction)(() => {
                        this.isAdyenPaymentMethod = false;
                    });
                    return;
                }
                ShopwarePaymentMethods_1.default.isAdyenPaymentMethod(ShopwareContext_1.default.currentPaymentMethod.id)
                    .then((0, mobx_1.action)((isAdyenPaymentMethod) => {
                    this.isAdyenPaymentMethod = isAdyenPaymentMethod;
                }))
                    .catch((0, mobx_1.action)(() => {
                    this.isAdyenPaymentMethod = false;
                }))
                    .finally(() => {
                    this.isSubmitButtonReady = true;
                });
            })
                .then((0, mobx_1.action)(() => {
                this.hasTaxId = !!ShopwareContext_1.default.contextExtension?.taxId;
                return ShopwareCart_1.default.loadCart().then(() => {
                    if (ShopwareCart_1.default.productsCount === 0) {
                        (0, history_1.pushHistory)(this.props.history, Paths_1.PATH_SHOP_CART);
                        return;
                    }
                    this.purchaseOrderNumberReactionDisposer = (0, mobx_1.reaction)(() => ShopwareContext_1.default.contextExtension?.massivePurchaseOrderNumber, (purchaseOrderNumber) => {
                        this.purchaseOrderNumber = purchaseOrderNumber ?? '';
                    }, { fireImmediately: true });
                    this.taxIdReactionDisposer = (0, mobx_1.reaction)(() => ShopwareContext_1.default.contextExtension?.taxId, (taxId) => {
                        this.taxId = taxId ?? '';
                    }, { fireImmediately: true });
                });
            }))
                .finally((0, mobx_1.action)(() => (this.initialLoading = false)));
        })();
    }
    componentWillUnmount() {
        this.purchaseOrderNumberReactionDisposer?.();
        this.taxIdReactionDisposer?.();
    }
    render() {
        return (react_1.default.createElement(ShopCheckoutLayout_1.default, { title: (0, translation_1.t)('shop_checkout_summary_page.page_title'), showSidebarMobile: true, submitElement: this.renderSubmitElement(), loading: this.initialLoading },
            react_1.default.createElement("h3", { className: "znd-shop-checkout-shipping__headline t-headline-3" }, (0, translation_1.t)('shop_checkout_summary_page.personal_info')),
            react_1.default.createElement("div", { className: "znd-shop-checkout-shipping__addresses znd-shop-checkout-shipping__addresses--summary d-flex flex-column flex-md-row" },
                ShopwareCart_1.default.hasProductWithCategorySoftware ? null : (react_1.default.createElement("div", { className: "znd-shop-checkout-shipping__addresses__column znd-shop-checkout-shipping__addresses__column--summary" },
                    react_1.default.createElement("div", { className: "znd-shop-select-address__subhead" },
                        react_1.default.createElement("span", { className: 't-subhead-1' }, (0, translation_1.t)('shop_checkout_summary_page.shipping_address')),
                        react_1.default.createElement(react_router_hash_link_1.HashLink, { className: 'ml-3 t-body-small font-weight-bold', to: (0, path_1.localePath)(Paths_1.PATH_SHOP_CHECKOUT_SHIPPING) }, (0, translation_1.t)('shop_checkout_summary_page.change'))),
                    this.shippingAddress ? (react_1.default.createElement(UserProfileAddress_1.default, { className: " znd-shop-select-address__details", address: this.shippingAddress, showOnlyAddress: true })) : null)),
                react_1.default.createElement("div", { className: (0, classnames_1.default)('znd-shop-checkout-shipping__addresses__column', 'znd-shop-checkout-shipping__addresses__column--summary', { 'ml-0': ShopwareCart_1.default.hasProductWithCategorySoftware }) },
                    react_1.default.createElement("div", { className: "znd-shop-select-address__subhead" },
                        react_1.default.createElement("span", { className: 't-subhead-1' }, (0, translation_1.t)('shop_checkout_summary_page.billing_address')),
                        react_1.default.createElement(react_router_hash_link_1.HashLink, { className: 'ml-3 t-body-small font-weight-bold', to: {
                                pathname: (0, path_1.localePath)(Paths_1.PATH_SHOP_CHECKOUT_SHIPPING),
                                hash: '#billing-address',
                            } }, (0, translation_1.t)('shop_checkout_summary_page.change'))),
                    this.billingAddress ? (react_1.default.createElement(UserProfileAddress_1.default, { className: (0, classnames_1.default)('znd-shop-select-address__details', {
                            'mt-0': ShopwareCart_1.default.hasProductWithCategorySoftware,
                        }), address: this.billingAddress, showOnlyAddress: true })) : null)),
            react_1.default.createElement("div", { className: "znd-shop-checkout-summary-order-data d-flex flex-column flex-md-row" },
                react_1.default.createElement("div", { className: "znd-shop-checkout-summary-order-data__column" },
                    react_1.default.createElement("div", { className: "znd-shop-checkout-summary__purchase-order__subhead t-subhead-1" },
                        (0, translation_1.t)('shop_checkout_purchase_order.label'),
                        this.checkoutRequiresPurchaseOrderNumber ? react_1.default.createElement("span", { className: "required" }, "*") : null),
                    react_1.default.createElement("input", { key: "purchaseOrderNumber", type: "text", required: this.checkoutRequiresPurchaseOrderNumber, className: "znd-shop-checkout-summary__purchase-order__input form-control", value: this.purchaseOrderNumber, maxLength: 30, placeholder: (0, translation_1.t)('shop_checkout_purchase_order.placeholder'), disabled: this.initialLoading || ShopwareContext_1.default.isLoading || this.isCreatingOrder, onChange: (0, mobx_1.action)((event) => {
                            this.purchaseOrderNumber = event.target.value;
                        }), onBlur: this.updatePurchaseOrderNumber })),
                this.checkoutRequiresTaxId ? (react_1.default.createElement("div", { className: "znd-shop-checkout-summary-order-data__column ml-md-auto" },
                    react_1.default.createElement("div", { className: "znd-shop-checkout-summary__tax-id__subhead t-subhead-1" },
                        (0, translation_1.t)('shop_checkout_tax_id.label'),
                        " ",
                        react_1.default.createElement("span", { className: "required" }, "*")),
                    react_1.default.createElement("input", { key: "taxId", type: "text", required: true, className: "znd-shop-checkout-summary__tax-id__input form-control", value: this.taxId, maxLength: 255, placeholder: (0, translation_1.t)('shop_checkout_tax_id.placeholder'), disabled: this.initialLoading || ShopwareContext_1.default.isLoading || this.isCreatingOrder, onChange: (0, mobx_1.action)((event) => {
                            this.taxId = event.target.value;
                        }), onBlur: this.updateTaxId }))) : null),
            ShopwareCart_1.default.hasProductWithCategorySoftware ? null : (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("div", { className: "znd-shop-select-address__subhead znd-shop-select-address__subhead--section t-subhead-1" },
                    react_1.default.createElement("span", null, (0, translation_1.t)('shop_checkout_summary_page.shipping_method')),
                    react_1.default.createElement(react_router_hash_link_1.HashLink, { className: 'ml-3 t-body-small font-weight-bold', to: {
                            pathname: (0, path_1.localePath)(Paths_1.PATH_SHOP_CHECKOUT_SHIPPING),
                            hash: '#shipping-method',
                        } }, (0, translation_1.t)('shop_checkout_summary_page.change'))),
                ShopwareContext_1.default.currentShippingMethod ? (react_1.default.createElement(ShopCheckoutSummaryMethod_1.default, { key: ShopwareContext_1.default.currentShippingMethod.id, name: this.shippingMethodLabel, media: ShopwareContext_1.default.currentShippingMethod.media ?? undefined })) : null)),
            ShopwareContext_1.default.currentPaymentMethod ? (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("div", { className: "znd-shop-select-address__subhead znd-shop-select-address__subhead--section t-subhead-1" },
                    react_1.default.createElement("span", null, (0, translation_1.t)('shop_checkout_summary_page.payment_method')),
                    react_1.default.createElement(react_router_hash_link_1.HashLink, { className: "ml-3 t-body-small font-weight-bold", to: (0, path_1.localePath)(Paths_1.PATH_SHOP_CHECKOUT_PAYMENT) }, (0, translation_1.t)('shop_checkout_summary_page.change'))),
                react_1.default.createElement(ShopCheckoutSummaryMethod_1.default, { name: ShopwareContext_1.default.currentPaymentMethod.translated?.name ?? '', media: ShopwareContext_1.default.currentPaymentMethod.media ?? undefined }))) : null,
            react_1.default.createElement("div", { className: "znd-shop-select-address__subhead znd-shop-select-address__subhead--section t-subhead-1" },
                react_1.default.createElement("span", null, (0, translation_1.t)('shop_checkout_summary_page.subtitle'))),
            react_1.default.createElement("div", { className: "znd-shop-checkout-summary__comment-area" },
                react_1.default.createElement("input", { value: this.customerComment, onChange: (0, mobx_1.action)((e) => {
                        this.customerComment = e.target.value;
                    }), className: "znd-shop-checkout-summary__comment-input form-control", maxLength: 55 }))));
    }
    renderSubmitElement() {
        const termsAndConditionsText = (0, translation_1.t)('shop_checkout_summary_page.terms_and_conditions', {
            channel: AuthorizationStore_1.default.channelId,
        });
        return (react_1.default.createElement(react_1.default.Fragment, null,
            !!termsAndConditionsText ? (react_1.default.createElement("div", { className: "znd-shop-checkout-summary__checkbox-container" },
                react_1.default.createElement("label", { className: "custom-control custom-checkbox znd-shop-checkout-summary__checkbox-label" },
                    react_1.default.createElement("input", { type: "checkbox", required: true, className: "custom-control-input", onChange: (0, mobx_1.action)((event) => {
                            this.isCheckedTermsAndConditions = event.target.checked;
                        }) }),
                    react_1.default.createElement("span", { className: "custom-control-label", dangerouslySetInnerHTML: { __html: termsAndConditionsText } })))) : null,
            react_1.default.createElement(Button_1.default, { className: "znd-shop-checkout-summary__submit", variant: ButtonVariant_1.default.primary, text: (0, translation_1.t)('shop_checkout_summary_page.submit_button', {
                    payment: this.isAdyenPaymentMethod ? 'required' : '',
                }), onClick: this.onCreateOrder, loading: this.isLoading, disabled: this.buttonIsDisabled }),
            this.checkoutRequiresPurchaseOrderNumber ? (react_1.default.createElement("p", { className: (0, classnames_1.default)('znd-shop-checkout-summary__error-information', {
                    'znd-shop-checkout-summary__error-information--hide': !!this.purchaseOrderNumber,
                }) }, (0, translation_1.t)('shop_checkout_summary_page.purchase_order_number_missing'))) : null,
            this.checkoutRequiresTaxId ? (react_1.default.createElement("p", { className: (0, classnames_1.default)('znd-shop-checkout-summary__error-information', {
                    'znd-shop-checkout-summary__error-information--hide': !!this.taxId,
                }) }, (0, translation_1.t)('shop_checkout_summary_page.tax_id_missing'))) : null));
    }
    onCreateOrder() {
        this.isCreatingOrder = true;
        this.promiseCheckoutDataPromise
            .then((0, mobx_1.action)(() => this.loadingCounter++))
            .then((0, mobx_1.action)(() => {
            if (!this.checkoutRequiresTaxId || this.hasTaxId) {
                return;
            }
            react_toastify_1.toast.error((0, translation_1.t)('shop_checkout_tax_id.error', { type: !this.taxId ? 'missing' : 'invalid' }));
            this.isCreatingOrder = false;
            return Promise.reject();
        }))
            // only pass comment if its non empty
            .then(() => ShopwareOrder_1.default.createOrder(this.customerComment.length ? this.customerComment : undefined))
            .then((payInformation) => {
            if (!payInformation.isAdyenPayment) {
                return (0, history_1.pushHistory)(this.props.history, Paths_1.PATH_SHOP_CHECKOUT_CONFIRMATION.replace(':orderId', payInformation.orderId));
            }
            return (0, history_1.pushHistory)(this.props.history, Paths_1.PATH_SHOP_CHECKOUT_PAY.replace(':orderId', payInformation.orderId));
        }, (response) => {
            response
                .json()
                .then(this.handleResponseErrors)
                .finally(() => {
                (0, history_1.pushHistory)(this.props.history, Paths_1.PATH_SHOP_CHECKOUT + '?reset=1');
            });
        })
            .finally((0, mobx_1.action)(() => {
            this.loadingCounter--;
        }));
    }
    redirectToCheckout() {
        return (0, history_1.pushHistory)(this.props.history, Paths_1.PATH_SHOP_CHECKOUT_PAYMENT);
    }
    onSelectReseller(resellerExternalId) {
        this.loadingCounter++;
        return ShopwareContext_1.default.setMassiveResellerId(resellerExternalId)
            .then(() => ShopwareCart_1.default.loadCart)
            .then(noop_1.noop)
            .finally((0, mobx_1.action)(() => {
            this.loadingCounter--;
        }));
    }
    updatePurchaseOrderNumber() {
        this.loadingCounter++;
        this.promiseCheckoutDataPromise = this.promiseCheckoutDataPromise.then(() => ShopwareContext_1.default.setMassivePurchaseOrderNumber(!!this.purchaseOrderNumber ? this.purchaseOrderNumber : null)
            .then(() => ShopwareCart_1.default.loadCart())
            .then(noop_1.noop)
            .catch(noop_1.noop)
            .finally((0, mobx_1.action)(() => {
            this.loadingCounter--;
        })));
        return this.promiseCheckoutDataPromise;
    }
    updateTaxId() {
        this.loadingCounter++;
        this.hasTaxId = false;
        this.promiseCheckoutDataPromise = this.promiseCheckoutDataPromise.then(() => ShopwareContext_1.default.setTaxId(!!this.taxId ? this.taxId : null)
            .then((0, mobx_1.action)(() => {
            this.hasTaxId = !!ShopwareContext_1.default.contextExtension?.taxId;
        }))
            .then(() => ShopwareCart_1.default.loadCart())
            .then(noop_1.noop)
            .catch((error) => {
            if (this.isCreatingOrder) {
                return Promise.reject(error);
            }
            this.handleResponseErrors(error);
        })
            .finally((0, mobx_1.action)(() => {
            this.loadingCounter--;
        })));
        return this.promiseCheckoutDataPromise;
    }
    handleResponseErrors(data) {
        if (Array.isArray(data?.errors)) {
            data?.errors?.forEach((error) => {
                const messageKey = error?.meta?.parameters?.messageKey;
                const errorLevel = error?.meta?.parameters?.level?.toString() ?? null;
                if (!messageKey || null === errorLevel) {
                    return;
                }
                const errorMessage = (0, translation_1.translateNoFallback)(`cart_errors.${messageKey.replace(/-/g, '_')}`);
                switch (parseInt(errorLevel)) {
                    case CartErrorLevels_1.default.error:
                        react_toastify_1.toast.error(errorMessage);
                        break;
                    case CartErrorLevels_1.default.warning:
                        react_toastify_1.toast.warning(errorMessage);
                        break;
                    case CartErrorLevels_1.default.notice:
                        react_toastify_1.toast.info(errorMessage);
                        break;
                }
            });
        }
    }
}
__decorate([
    bind_decorator_1.default
], ShopCheckoutSummary.prototype, "renderSubmitElement", null);
__decorate([
    bind_decorator_1.default
], ShopCheckoutSummary.prototype, "redirectToCheckout", null);
exports.default = (0, mobx_react_1.observer)(ShopCheckoutSummary);
